import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import styles from './TextCheckboxList.module.scss';
export function TextCheckboxList({ options, onChange, initialShow = 6, facetName = '', }) {
    const [showAll, setShowAll] = useState(false);
    const [optimisticOptions, setOptimisticOptions] = useState(options);
    const visibleOptions = showAll ? optimisticOptions : optimisticOptions.slice(0, initialShow);
    // Update optimistic options when props change (API response)
    useEffect(() => {
        setOptimisticOptions(options);
    }, [options]);
    const isToggle = optimisticOptions.length === 1 && optimisticOptions[0].id === 'false';
    const handleOptionChange = (optionId) => {
        // Optimistically update the UI immediately
        setOptimisticOptions(prevOptions => prevOptions.map(option => {
            if (option.id === optionId) {
                return Object.assign(Object.assign({}, option), { selected: !option.selected });
            }
            return option;
        }));
        // Call the actual onChange handler
        onChange(optionId);
    };
    const getToggleLabel = () => {
        if (facetName.toLowerCase().includes('availability')) {
            return 'Availability';
        }
        if (facetName.toLowerCase().includes('in stock')) {
            return 'In Stock Only';
        }
        return facetName || 'Toggle';
    };
    if (isToggle) {
        const option = optimisticOptions[0];
        return (h("div", { className: styles.toggleContainer },
            h("label", { className: styles.toggleLabel },
                h("input", { type: "checkbox", checked: option.selected, onChange: () => handleOptionChange(option.id), className: styles.toggleInput }),
                h("span", { className: styles.toggleSlider }),
                h("span", { className: styles.toggleText }, getToggleLabel()))));
    }
    return (h("div", { className: styles.textCheckboxList },
        visibleOptions.map((option) => {
            let label = option.label;
            if (option.label.includes(':')) {
                label = option.label.split(':')[1];
            }
            return (h("label", { key: option.id, className: styles.checkboxLabel },
                h("input", { type: "checkbox", checked: option.selected, onChange: () => handleOptionChange(option.id) }),
                h("span", { className: `${styles.checkboxText} ${option.selected ? styles.selected : ''}` }, label),
                h("span", { className: `${styles.count} ${option.selected ? styles.selected : ''}` }, option.count)));
        }),
        optimisticOptions.length > initialShow && (h("button", { className: styles.showMore, onClick: () => setShowAll(!showAll) }, showAll ? 'Show Less' : `Show ${optimisticOptions.length - initialShow} More`))));
}
